<template>
  <div>
    <hr />
    <SocietyCSVUploadRowError
      v-for="(message, index) in messages"
      :key="rowNumber + index"
      :rowNumber="rowNumber"
      :message="message"
    />
  </div>
</template>

<script>
import SocietyCSVUploadRowError from './SocietyCSVUploadRowError';

export default {
  name: 'SocietyCSVUploadRowErrors',
  components: {
    SocietyCSVUploadRowError,
  },
  props: {
    rowNumber: String,
    messages: Object,
  },
};
</script>

<style scoped></style>
